import type { OrderData } from "../components/OrderList/OrderList";

// Dev-only fixture: a representative spread of LMU TV keys used by both
// /account (OrderList) and the cart (renewal-suggestion UI). Kept in one place
// so both surfaces stay consistent and changes to the demo data show up
// everywhere at once.
export function buildSampleOrders(): OrderData[] {
    const now = new Date();
    const plus = (days: number | null): string | null => {
        if (days === null) return null;
        const d = new Date(now);
        d.setDate(d.getDate() + days);
        return d.toISOString();
    };
    const minus = (days: number): string => {
        const d = new Date(now);
        d.setDate(d.getDate() - days);
        return d.toISOString();
    };
    const tiers: Array<{
        tier: string;
        features: number;
        days: number | null;
        daysOld: number;
        resetDaysAgo: number | null;
    }> = [
        { tier: "Standard 90 Days", features: 1, days: 90,   daysOld: 1,   resetDaysAgo: null },
        { tier: "Standard 1 Year",  features: 1, days: 365,  daysOld: 30,  resetDaysAgo: 10 },
        { tier: "Standard Lifetime",features: 1, days: null, daysOld: 90,  resetDaysAgo: 89 },
        { tier: "Pro 90 Days",      features: 4, days: 90,   daysOld: 2,   resetDaysAgo: null },
        { tier: "Pro 1 Year",       features: 4, days: 365,  daysOld: 60,  resetDaysAgo: 60 },
        { tier: "Pro Lifetime",     features: 4, days: null, daysOld: 120, resetDaysAgo: 95 },
    ];
    return tiers.map((t, i) => ({
        id: 1000 + i,
        ident: `sample-${t.tier.toLowerCase().replace(/ /g, "-")}-0000-0000-0000-${String(i).padStart(12, "0")}`,
        owner: `Dev User (${t.tier})`,
        discordId: null,
        created: minus(t.daysOld),
        features: t.features,
        refunded: false,
        steamId: 76561198000000000 + i,
        strSteamId: `STEAM_0:0:${10000 + i}`,
        steamIdBindingTime: minus(t.daysOld),
        affiliate: "",
        validUntil: plus(t.days),
        lastSteamReset: t.resetDaysAgo === null ? null : minus(t.resetDaysAgo),
    }));
}
